import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { showToaster } from '../../../redux/reducers/shared.reducer';
import { ErrorMessage, ToasterType } from '../../../types';
import API from '../../../service/api.service';
import { Link } from 'react-router-dom';
import { routes_constants } from '../../../service/constants';

export const TermsAndConditionComponent = () => {
    // const [loading, setLoading] = useState(false);
    const [content, setContent] = useState('');
    const dispatch = useDispatch<AppDispatch>();

    const fetchContent = async () => {
        const params = {
            "template_name": "PATIENT_MEDICAL_CONTRACT_TERMS",
            "type": 3,
            "user_type": "patient",
        };

        // setLoading(true);
        const response = await API({
            api: "support/cms_details_for_panel",
            type: "POST",
            body: params
        });
        // setLoading(false);

        if (!response || (response.is_error && response.is_error === 1)) {
            dispatch(showToaster({ message: ((response?.original_override_text || response?.original_text) || ErrorMessage.SOMETHING_WRONG), type: ToasterType.Danger, status: true }));
        }
        else{
            //
            const content = response?.data?.length ? response.data[0].content : '';
            setContent(content);
        }
    }

    useEffect(() => {
        if(!content){
            fetchContent();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); 

  return (
    <>
      <div>
        <div className="support-wrapper vh-100 overflow-hidden">
          <div className="support-header hw-65 w-100 d-flex align-items-center justify-content-between border-bottom px-4 py-2">
            <img src="../../assets/images/FM-logo.svg" alt="" />
          </div>
          <div className='d-flex h-100' style={{maxHeight: 'calc(100% - 65px)'}}>
          <div className="support-content h-100 p-3 d-flex align-items-start">
            <Link to={routes_constants.support} className="decoration-none">
              <img
                src="../../assets/images/back-circle.png"
                className="hw-40 rounded-circle me-3"
                alt=""
              />
            </Link>
            <Link to={routes_constants.support} className="decoration-none">
              <p className="fs-16 fw-700 mt-2 black-70">Back to help</p>
            </Link>
          </div>
          <div className='m-auto h-100 overflow-auto hide-scroll-bar'>
          <div className="container-xl pt-5">
            <div className="faq-inner">
              <div className="text-center mb-5">
                <h1 className="fs-40 fw-700 mb-3 text-black">
                  FinanceMutual™ Customer Terms and Conditions
                </h1>
                <p className="fs-16 fw-400 m-0 text-muted">&nbsp;</p>
              </div>
              <div
                className="faq-body"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>
            </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}
